export default "__VITE_ASSET__9oQSkScJ__"